import { c as _c } from "react/compiler-runtime";
import { useToggle } from '@onefootprint/hooks';
import { Button, Divider } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import PermissionGate from '@/components/permission-gate';
import CreateDialog from '@/components/roles/create-dialog';
import SectionHeader from '@/components/section-header';
import Table from './table';
const Roles = () => {
  const $ = _c(27);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "roles"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("api-keys", t0);
  const [isCreateDialogOpen, openCreateDialog, closeCreateDialog] = useToggle(false);
  let t1;
  if ($[1] !== t) {
    t1 = t(_temp);
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t) {
    t2 = t(_temp2);
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t(_temp3);
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t) {
    t4 = t(_temp4);
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== openCreateDialog || $[10] !== t4) {
    t5 = <Button variant="secondary" onClick={openCreateDialog}>{t4}</Button>;
    $[9] = openCreateDialog;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t3 || $[13] !== t5) {
    t6 = <PermissionGate fallbackText={t3} scopeKind="api_keys">{t5}</PermissionGate>;
    $[12] = t3;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t1 || $[16] !== t2 || $[17] !== t6) {
    t7 = <SectionHeader title={t1} subtitle={t2}>{t6}</SectionHeader>;
    $[15] = t1;
    $[16] = t2;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  let t9;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="mt-4 mb-4"><Divider /></div>;
    t9 = <Table />;
    $[19] = t8;
    $[20] = t9;
  } else {
    t8 = $[19];
    t9 = $[20];
  }
  let t10;
  if ($[21] !== closeCreateDialog || $[22] !== isCreateDialogOpen) {
    t10 = <CreateDialog open={isCreateDialogOpen} onClose={closeCreateDialog} kind="api_key" />;
    $[21] = closeCreateDialog;
    $[22] = isCreateDialogOpen;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== t10 || $[25] !== t7) {
    t11 = <>{t7}{t8}{t9}{t10}</>;
    $[24] = t10;
    $[25] = t7;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  return t11;
};
export default Roles;
function _temp($) {
  return $.header.title;
}
function _temp2($_0) {
  return $_0.header.subtitle;
}
function _temp3($_1) {
  return $_1.header.ctaNotAllowed;
}
function _temp4($_2) {
  return $_2.header.cta;
}